<template>
	<strong :class="[fontFamily, color, {solid: isSolid}, {bold: bold}, size]" class="badge">
		<slot>{{value}}</slot>
	</strong>
</template>

<script>
import badgeMixin from './badgeMixin';
export default {
	name: 'TBadge',
	mixins: [badgeMixin],
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/text';
@import './badgeMixin';

.badge {
	@include colors();
	@extend %text-small;
	font-weight: 600;
	text-transform: uppercase;
	border-radius: 2px;
	padding: 0px 6px;
	text-align: center;
	display: inline-block;
	height: 16px;
	margin-top: 0;

	//FontFamily
	&.ui {
		@extend %font-families-ui;
	}
	&.display {
		@extend %font-families-display;
	}
	&.mono {
		@extend %font-families-mono;
	}
	&.bold {
		font-weight: 700;
	}
	&.sm, &.small {
		font-size: 10px;
		height: 14px;
		line-height: 14px;
		padding: 0px 4px;
	}
	&.md, &.medium {
		font-size: 12px;
		height: 16px;
		line-height: 16px;
		padding: 0px 6px;
	}
	&.lg, &.large {
		font-size: 14px;
		height: 32px;
		line-height: 32px;
		padding: 0px 12px;
	}
}

</style>


<docs>
## Examples

### Default

```jsx noeditor
<div style="display: inline-grid; grid-column-gap: 10px; grid-row-gap: 10px; grid-template-columns: repeat(8, auto);">
	<t-badge>Neutral</t-badge>
	<t-badge color="green">GREEN</t-badge>
	<t-badge color="blue">BLUE</t-badge>
	<t-badge color="red">RED</t-badge>
	<t-badge color="orange">ORANGE</t-badge>
	<t-badge color="purple">PURPLE</t-badge>
	<t-badge color="yellow">YELLOW</t-badge>
	<t-badge color="teal">TEAL</t-badge>
</div>
```
#### Example Code
```html
	<t-badge color="green">green</t-badge>
```

### Solid

```jsx noeditor
<div style="display: inline-grid; grid-column-gap: 10px; grid-row-gap: 10px; grid-template-columns: repeat(8, auto);">
	<t-badge isSolid>Neutral</t-badge>
	<t-badge color="green" isSolid>GREEN</t-badge>
	<t-badge color="blue" isSolid>BLUE</t-badge>
	<t-badge color="red" isSolid>RED</t-badge>
	<t-badge color="orange" isSolid>ORANGE</t-badge>
	<t-badge color="purple" isSolid>PURPLE</t-badge>
	<t-badge color="yellow" isSolid>YELLOW</t-badge>
	<t-badge color="teal" isSolid>TEAL</t-badge>
</div>
```
#### Example Code
```html
	<t-badge color="green" isSolid>green</t-badge>
```

### Size

```jsx
<div style="display: inline-grid; grid-column-gap: 10px; grid-row-gap: 10px; grid-template-columns: repeat(8, auto); align-items: center;">
	<t-badge size="sm">Small</t-badge>
	<t-badge size="md">Medium</t-badge>
	<t-badge size="lg">Large</t-badge>
</div>
```
</docs>
